import React, { useEffect, useState, useCallback } from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import BodegaModule from '../modules/BodegaModule';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function BodegaAcceso() {
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const token = params.get('token');
  const orderId = params.get('order');
  const [employee, setEmployee] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    setLoading(true); setError('');
    try {
      if (token) {
        const res = await fetch(`${API_BASE}/api/orders/warehouse/acceso?token=${encodeURIComponent(token)}`);
        const json = await res.json();
        if (!json.ok) throw new Error(json.error || 'Token inválido');
        setEmployee(json.employee);
        setOrders(json.orders || []);
      } else if (orderId) {
        const res = await fetch(`${API_BASE}/api/orders/warehouse`);
        const json = await res.json();
        setOrders((json.orders || json.items || []).filter(o => o.id === orderId));
      } else {
        const res = await fetch(`${API_BASE}/api/orders/warehouse`);
        const json = await res.json();
        setOrders(json.orders || json.items || []);
      }
    } catch (e) { setError(e.message); }
    setLoading(false);
  }, [token, orderId]);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (loading) return (
    <Box sx={{ maxWidth: 600, mx: 'auto', px: 2, py: 8, textAlign: 'center', minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body2" color="text.secondary">Cargando...</Typography>
    </Box>
  );

  if (error) return (
    <Box sx={{ maxWidth: 600, mx: 'auto', px: 2, py: 8, textAlign: 'center', bgcolor: '#f8fafc' }}>
      <Typography color="error" sx={{ fontWeight: 600, mb: 2 }}>{error}</Typography>
      <Button variant="contained" onClick={fetchData} sx={{ borderRadius: 2 }}>Reintentar</Button>
    </Box>
  );

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', px: 2, py: 2, minHeight: '100vh', bgcolor: '#f8fafc' }}>
      {employee && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, p: 1.5, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 16 }}>👷</Box>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>{employee.name || employee.nombre || 'Operario'}</Typography>
            <Typography variant="caption" color="text.secondary">{orders.length} orden(es) activa(s)</Typography>
          </Box>
        </Box>
      )}
      <BodegaModule orders={orders} setOrders={setOrders} readOnly={!employee} />
    </Box>
  );
}
